import React, { useEffect } from 'react';
import { V2TextInput } from '@uhg-abyss/web/ui/TextInput';

export const OptumId = () => {
  useEffect(() => {}, []);

  return (
    <React.Fragment>
      <V2TextInput
        label="OptumID"
        model="searchDraft.optumId"
        required
        id="optumId-textinput"
        aria-label="Type here to Enter a OptumID "
        validators={{
          required: 'OptumID is required.',
          validate: {
            spaceInOptumId: (value) => {
              return value.includes(' ')
                ? 'OptumID is invalid. Please remove spaces.'
                : true;
            },
          },
        }}
        isClearable
        autoComplete="off"
      />
    </React.Fragment>
  );
};

OptumId.propTypes = {};

OptumId.defaultProps = {};
